<template>
  <div class="px-4 pb-4 text-center">
    <b-form>
      <b-form-group>
        <b-input v-model="child.firstname" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Vorname" />
        <img v-show="checkName(child.firstname)" class="input-correct" :src="'./static/img/' + $current_user.role +'/check_filled.png'">
      </b-form-group>
      <b-form-group>
        <b-input v-model="child.lastname" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Nachname" />
        <img v-show="checkName(child.lastname)" class="input-correct" :src="'./static/img/' + $current_user.role +'/check_filled.png'">
      </b-form-group>
      <alert :success="alert.success" :error="alert.error"/>
    </b-form>
  </div>
</template>

<script>
import Alert from '@/components/Helpers/Alert';

export default {
  components: { Alert },
  props: ['child', 'alert'],
  methods: {
    checkName: function (name) {
      if(name==undefined){
        return false;
      }
      if (name.length < 1 || name.length > 25) {
        return false;
      }

      if (!this.validWhiteSpace(name)) {
        return false;
      }

      return true;
    },

    validWhiteSpace: function (name) {
      var re = /^\S/;
      return re.test(name);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Student/Form.vue